import { Button, ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DeclineButton(props: Pick<ButtonProps, 'onClick'>) {
    const { t } = useTranslation('candidateOffers');

    return (
        <Button variant="outlined" 
            { ...props }
        >
            { t('decline') }
        </Button>
    );
}

